export default "__VITE_ASSET__7aa1a782__"